<template>
  <div class="table-wapper">
    <table>
      <thead>
      <tr class="tittle-table">
        <th colspan="3"></th>
        <th :colspan="colsLength() || 4">{{ timeType }}</th>
      </tr>
      <tr class="label-row" v-if="colsLength() > 0">
        <th colspan="3" class="text-left capitalize">{{ getName() }}</th>
        <th v-for="(colName, index) in colsData" :key="index">{{ formatDate(colName) }}</th>
      </tr>
      </thead>
      <tbody v-if="colsLength() > 0">
      <tr class="total-rows text-left" v-for="(item, keyText) in reportData.items" :key="keyText">
        <td colspan="3" class="row-label text-left">{{ reportData.title[keyText] }}</td>
        <td v-for="(price, index) in item" :key="index">{{ contVertMoney(price) }}</td>
      </tr>
      <tr class="total-rows text-left total_report">
        <th class="row-label" colspan="3">
          <p>Totals</p>
        </th>
        <td v-for="(colName, index) in colsData" :key="index">{{ totalPriceByCol(colName) }}</td>
      </tr>
      </tbody>
      <tbody v-if="colsLength() <= 0">
      <tr class="no-data">
        <td colspan="12">No data</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import currencyFormatter from 'currency-formatter'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
export default {
  name: 'UITable',
  props: {
    timeType: {
      type: String,
      default: 'Day'
    },
    labelTime: {
      type: Array,
      default: () => []
    },
    reportData: {
      type: Object,
      default: () => {}
    },
    colsData: {
      type: Array,
      default: () => {}
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    ...mapGetters({
      getQuery: 'report/getQuery'
    })
  },
  methods: {
    getName () {
      return this.$route.name
    },
    contVertMoney (money) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return currencyFormatter.format(Number(money) * Number(currentCurrent?.rate || '1'), { code: currentCurrent?.toCurrency || storeConfig.currency, decimalDigits: 2 })
    },
    totalPriceByCol (colName) {
      if (this.reportData === undefined || this.reportData.items === undefined) {
        return this.contVertMoney(0)
      }

      let total = 0
      Object.keys(this.reportData.items).forEach(item => {
        total += parseFloat(this.reportData.items[item][colName] ? (item.includes('Refunded') ? `-${this.reportData.items[item][colName]}` : this.reportData.items[item][colName]) : '0')
      })
      return this.contVertMoney(total)
    },
    colsLength () {
      if (this.colsData === undefined) {
        return 0
      }

      let total = 0
      this.colsData.forEach(item => {
        total += 1
      })
      return total
    },
    getDateOfWeek (week) {
      const date = new Date(this.getQuery.createdAtMin)
      const day = (1 + (Number(week) - 1) * 7)
      const currenDate = new Date(date.getFullYear(), 0, day)
      const firstDayOfWeeks = currenDate.getDate() - currenDate.getDay()
      const startDate = new Date(currenDate.setDate(firstDayOfWeeks))
      return startDate.toDateString()
    },
    formatDate (date) {
      if (this.timeType === 'YEAR' || this.timeType === 'MONTH') {
        return date
      }
      if (this.timeType === 'WEEK') {
        return this.getDateOfWeek(date)
      }
      return new Date(date).toDateString()
    }
  }
}
</script>

<style lang="scss" scoped>
  .table-wapper {
    overflow-x: auto;
    overflow-y: hidden;

    table {
      width: 100%;
      color: #333;
      border: 0 solid #e4e3e4;
      border-collapse: collapse;
      border-spacing: 0;
      background-color: #fff;
      border-width: 1px 0 0 1px;
      border-radius: 7px;
      letter-spacing: 0;
      font-size: 15px;
      font-weight: 400;

      td,
      tr,
      th {
        border: 1px solid #e4e3e4;
        font-weight: 400;
        font-size: 14px;
      }

      .no-padding {
        padding: 6px 5px !important;
      }

      .text-left {
        text-align: left !important;
      }
      .capitalize {
        text-transform: capitalize;
      }

      .no-data {
        td {
          padding: 15px;
          text-align: left;
        }
      }

      .tittle-table {
        color: #fff;
        background-color: #92a1ab;
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;

        th {
          font-size: 20px;
          font-weight: 700;
          text-transform: uppercase;
          border-bottom-width: 1px;
          padding-top: 2px;
          text-align: center;
          border: 1px solid #e4e3e4;
          padding: 15px;
        }

        .row-aggs-header {
          color: #fff;
          background-color: #92a1ab;
          text-align: center;
          font-weight: 300 !important;
        }
      }

      .tittle-table th:first-child {
        border-top-left-radius: 6px;
      }

      .tittle-table th:last-child {
        border-top-right-radius: 6px;
      }

      .label-row {
        color: #888;
        padding-left: 20px;

        th {
          padding: 15px 5px;
          border: 1px solid #e4e3e4;
          font-weight: 700;
          text-align: right;
        }

        .row-custom {
          background-color: rgba(65, 65, 65, 0.02);
          padding-left: 14px;
          text-align: right;
          font-weight: 600;
          cursor: pointer;
        }
      }

      .total_report {
        background-color: #f0f4f7 !important;
      }

      .total-rows {
        background-color: #fff;
        border-top-width: 1px;
        border-bottom-width: 1px;
        font-size: 14px;

        p {
          font-size: 15px;
          font-weight: 700;
        }

        th,
        td {
          padding: 15px 5px;
        }

        td {
          text-align: right;
          color: #333;
          font-weight: 700;
        }
      }

      .col-header {
        text-align: center;
        color: #fff;
        background-color: #92a1ab;
        font-size: 20px;
        padding: 20px 5px;

        .header-outer {
          text-align: center;
          position: relative;
          display: inline-table;
          padding: 3px 0;
          overflow-wrap: normal;

          .header-inner {
            writing-mode: vertical-rl;
            text-transform: uppercase;
            transform: rotate(-180deg);
            font-weight: 300;
            text-align: center;
          }
        }
      }

      .col-header {
        border-bottom-left-radius: 7px;
        border-bottom-width: 1px;
      }

      td {
        padding: 5px 15px;
        text-align: right;
      }
    }
  }
</style>
